// «Iniciar nueva consulta» desde la ficha: lo que decide la Sala antes de abrir el Encounter (Sala CRM↔HCE, rebanada 5; PLAN C11.5, toma automática).
//
// El servidor mira si el paciente tiene un turno activo hoy y responde. Aquí solo se traduce esa respuesta a lo que la ficha debe hacer; la regla
// de fondo (misma sede, especialidad, quién es el dueño) NO se repite en el navegador: la decide el servidor.
//
//   - sin turno / turno propio ya iniciado / cualquier falla de la Sala  -> seguir (la ficha abre el Encounter como siempre: NUNCA se bloquea la
//     atención por un problema de la Sala);
//   - turno de otro médico en espera                                      -> pedir confirmación («¿Atenderlo tú?»), sin escribir nada todavía;
//   - otra sede                                                           -> detener (solo un administrador lo reasigna);
//   - la consulta ya la tiene abierta otro médico                         -> seguir, con un aviso (queda la alerta para el administrador).
import { ErrorSala, iniciarConsultaDePaciente, type ResultadoIniciarPaciente } from '@/lib/salaHce';

export type DecisionInicio =
  | { tipo: 'seguir'; aviso?: { clave: 'consultaDeOtro'; medico: string | null } | { clave: 'salaLenta' } }
  | { tipo: 'confirmarToma'; deMedico: string | null; especialidadDistinta: boolean }
  | { tipo: 'detener'; motivo: 'otraSede' };

export async function decidirInicioEnSala(
  medplumPatientId: string,
  confirmarToma: boolean,
  llamar: (id: string, confirmar: boolean) => Promise<ResultadoIniciarPaciente> = iniciarConsultaDePaciente,
): Promise<DecisionInicio> {
  let r: ResultadoIniciarPaciente;
  try {
    r = await llamar(medplumPatientId, confirmarToma);
  } catch (err) {
    if (err instanceof ErrorSala && err.codigo === 'otra_sede') return { tipo: 'detener', motivo: 'otraSede' };
    // La Sala tardó demasiado (Medplum lento): la ficha sigue sola, pero se le dice al médico que el turno puede no haberse actualizado.
    if (err instanceof ErrorSala && err.codigo === 'tiempo_agotado') return { tipo: 'seguir', aviso: { clave: 'salaLenta' } };
    // Sesión de otro rol, Medplum o el servidor caídos, sin conexión…: la atención no depende de la Sala.
    return { tipo: 'seguir' };
  }
  if ('requiereConfirmacion' in r) return { tipo: 'confirmarToma', deMedico: r.deMedico, especialidadDistinta: r.especialidadDistinta };
  if ('resultado' in r && r.resultado === 'consulta_de_otro') return { tipo: 'seguir', aviso: { clave: 'consultaDeOtro', medico: r.deMedico } };
  return { tipo: 'seguir' };
}
